import { render, staticRenderFns } from "./TaiwanDatePicker.vue?vue&type=template&id=f85997e8&scoped=true"
import script from "./TaiwanDatePicker.vue?vue&type=script&lang=js"
export * from "./TaiwanDatePicker.vue?vue&type=script&lang=js"
import style0 from "./TaiwanDatePicker.vue?vue&type=style&index=0&id=f85997e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85997e8",
  null
  
)

export default component.exports